import { ReactNode, useEffect, useRef, useState } from "react";

import { ArtistResponseDTOMin } from "../../openapi-generated-client";
import { linearPartition } from "../../utils/arrayUtils";
import ArtistDisplay from "./artistDisplay";
import "./artistList.css";

interface ArtistListProps {
    artists: ArtistResponseDTOMin[];
    searchQuery: string;
    clickUrl: string;
    advanced? :boolean;
}

const MIN_WIDTH_COMPOSER = 360;
const MAX_ROW_AMOUNT = 4;

export default function ArtistList(props: ArtistListProps) {

    const [rows, setRows] = useState<ReactNode[]>([]);
    const composerListEl = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        updateRows();
        window.addEventListener("resize", updateRows);
        return () => {
            window.removeEventListener("resize", updateRows);
        }
    }, [props.artists, props.searchQuery]);

    function updateRows() {
        if(composerListEl.current) {

            const letterToComposer: { [key: string]: ArtistResponseDTOMin[] } = {};
        
            for(let i = 0; i < props.artists.length; i++) {
                var composer = props.artists[i];

                if(!composer.name?.toLowerCase().includes(props.searchQuery.toLowerCase())) continue;

                var firstLetter = composer.name.charAt(0).toLowerCase();
                if(!letterToComposer[firstLetter]) {
                    letterToComposer[firstLetter] = [composer];
                }else {
                    letterToComposer[firstLetter].push(composer);
                }
            }
    
            let rowAmount = Math.floor(composerListEl.current.clientWidth / MIN_WIDTH_COMPOSER);
            if(rowAmount < 1) rowAmount = 1;
            const letterFillStats: number[] = [];
            for(let letter in letterToComposer) {
                letterFillStats.push(letterToComposer[letter].length);
            }

            const partitionResult = linearPartition(letterFillStats, rowAmount);
            var y = 0;
            const newRows = [];
            for(var i = 0; i < partitionResult.length; i++) {
                const arr = partitionResult[i];
                const groups = [];
                for(var value of arr) {
                    const letter = Object.keys(letterToComposer)[y++];
                    const artists = letterToComposer[letter];
                    const group = [];
                    for (const artist of artists) {
                        group.push(<ArtistDisplay advanced={props.advanced} artist={artist} url={props.clickUrl}/>);
                    }
                    groups.push(<div className="artist-group">
                        <h1>{letter}</h1>
                        {group}
                    </div>);
                }
                newRows.push(<div className="artist-row">{groups}</div>);
                
            }
            setRows(newRows);
                
        }
    }

    return <div className="artist-list" ref={composerListEl}>
        {rows.map(row => {
            return <div className="artist-row">
                {row}
            </div>;
        })}
        </div>;

}